import {FieldController} from "./elements.field.controller";


class inputIdentityCardController  extends FieldController  {

    static get $inject(){ return   [
        "$element", 
        '$log',
        'BXReferenceService', 
        'referenceEntity',
        '$scope'
    ]}

    constructor($element, $log, BXReferenceService, referenceEntity, $scope) {
        super($log, $scope, $element)
        this.$element = $element;
  
        this.serialMask = '' ;
        this.numberMask = '' ;
        this.scope =$scope;
        
        
        this.reference = BXReferenceService;
       
        this.typeDocsOptions = [];
        this.ref  = this.reference
        .getReference('bid')
    }



    get TypeDocumentWeb(){
        return this.model.TypeDocumentWeb;
    }
    set TypeDocumentWeb(value){

        //console.log('set TypeDocumentWeb', value);
        this.model.TypeDocumentWeb = value ;
       
        this.model.DepCode = '';

        switch(this.model.TypeDocumentWeb){
            case 'RF':
                this.serialMask = '9999' ;
                this.numberMask = '999999' ;
                this.depCodeMask = '999-999'
                break;
            case 'INO':
                this.serialMask = '' ;
                this.numberMask = '' ;
                this.depCodeMask = '' ;
                break;
            case 'MINI':
                this.serialMask = '' ;
                this.numberMask = '999-999' ;
                this.depCodeMask = '' ;
                break;
        }
        
    
        this.redraw();
       

    }

    $onInit(){

        super.$onInit();

        
        if(this.ref.$$state){
            this.ref.then((data)=>{
                
                this.ref = data;
                this.setOptionsByListProps();
            })  
    
        }else{
            this.setOptionsByListProps();
            
        }

        if(!this.model){
            this.model = {}; 

        }
        if(!this.model.DateEnd){
            this.model.DateEnd = '';
        }
    }


    setOptionsByListProps(){
       
        let options = [];
        this.ref['PASPORT_TYPE'].items.forEach(item => {
            
            if(this.hideMini && item.value=='MINI'){
                return ;
            }


            let option ={
                id: item.value,
                text: item.label, 
               
            };

            if(item.id){
                option.optId= item.id;
            }

            if(this.model && this.model==option.id ){
                option.selected = true
            }

            options.push(option);
        });
        this.typeDocsOptions =  options;
    }


    onInitFields(event, data){
        this._fields[data.name.replace('model.','')] = data.field;

    }
    onChangeDocType(/*id,text*/){
        
       
        for (const key in this._fields) {
            if (Object.hasOwnProperty.call(this._fields, key)) {
                const element = this._fields[key];
                element.haveError = false;
                element.errorMessage = false;
            }
        }
 
    }

    onSaveForm  (event, data){

        if(this.skeepCheckFill){
            return ;
        }
       
        //    data.haveError(this);

        let errorFields = [] ;
        var haveError = false;

        switch(this.model.TypeDocumentWeb){
            case 'RF':

                /*
                ___Если Паспорт РФ, то: ___
                4. Серия = model.Serial добавить проверку
                5. Номер = model.Number добавить проверку
                6. Дата выдачи = model.FromDate добавить проверку
                7. Кем выдан = model.Org добавить проверку
                8. Код подразделения = model.DepCode добавить проверку

                */
               errorFields=[
                   'Serial',
                   'Number',
                   'FromDate',
                   'Org',
                   'DepCode'
               ];
                
                break;
            case 'INO':
               /*
               9. Серия = model.Serial добавить проверку
               10. Номер = model.Number добавить проверку
                11. Дата выдачи = model.FromDate добавить проверку
                12. Кем выдан = model.Org добавить проверку
                13. Страна = model.DepCode (почему-то тут тоже depcode как код подразделения) добавить проверку
                14. Срок действия = model.DateEnd добавить проверку

                */
               errorFields=[
                'Serial',
                    'Number',
                    'FromDate',
                    'Org',
                    'DepCode',
                    
                ];

                if(!this.model.NoDateEnd){
                    errorFields.push('DateEnd');
                }

                break;
            case 'MINI':
                /*
                15.1 Серия = model.Serial добавить проверку
                16. Номер = model.Number добавить проверку
                17. Дата выдачи = model.FromDate добавить проверку

                 */                
                errorFields=[
                    'Serial',
                    'Number',
                    'FromDate'
                ];
                break;
            default:
                haveError = true; 

                this.$scope.$broadcast('errorEvent',{
                    field: this._fields.TypeDocumentWeb.fieldName,
                    message:'Необходимо выбрать значение',
                })

                
                break;
        }

        errorFields.forEach(element => {
            if (Object.hasOwnProperty.call(this._fields , element)) {
                if(!this._fields[element].model){
                    haveError = true; 
                    this.$scope.$broadcast('errorEvent',{
                        field: this._fields[element].fieldName,
                        message:'Необходимо заполнить поле',
                    })

                }
            }
        });
        

        if(haveError){
            data.haveError(this);
        }

    }


    

}


export {


    inputIdentityCardController

}
;





// WEBPACK FOOTER //
// ./src/components/elements/input.identity.card.controller.js